const testimonials = [
  {
    id: 1,
    name: "Antecka J., Buyko M.",
    title: "'Teodora moja miłość. Życie codzienne Jana i Teodory Matejków'",
    org:
      "https://niezlasztuka.net/o-sztuce/milosc-zazdrosc-i-szalenstwo-jan-matejko-teodora-giebultowska",
    desc:
      "Jan w 1873 roku został dyrektorem Szkoły Sztuk Pięknych, a przede wszystkim był już ważną personą w świecie sztuki. Wykupił od rodzeństwa kamienicę przy ul. Floriańskiej, po uciążliwej przebudowie, rodzina w 1874 roku mogła przenieść się do znacznie wygodniejszego lokum. Do tego w 1876 roku malarz nabył majątek w Krzesławicach, Matejkowie zyskali więc własną letnią posiadłość i nie musieli już korzystać z uprzejmości krewnych.",
  },
  {
    id: 2,
    name: "Antecka J., Buyko M.",
    title: "'Teodora moja miłość. Życie codzienne Jana i Teodory Matejków'",
    org:
      "https://niezlasztuka.net/o-sztuce/milosc-zazdrosc-i-szalenstwo-jan-matejko-teodora-giebultowska",
    desc:
      "Do jednej z największych awantur w domu przy Floriańskiej doszło w 1876 roku. Wówczas oprócz Matejków mieszkała tam także owdowiała Joanna Serafińska z córkami. Pod nieobecność żony artysta poprosił o pozowanie do obrazu starszą z nich – Stanisławę. Jej piękny portret w stroju historycznym znany jest pod tytułem 'Kasztelanka'.",
  },
  {
    id: 3,
    name: "Antecka J., Buyko M.",
    title: "'Teodora moja miłość. Życie codzienne Jana i Teodory Matejków'",
    org:
      "https://niezlasztuka.net/o-sztuce/milosc-zazdrosc-i-szalenstwo-jan-matejko-teodora-giebultowska",
    desc:
      "Artysta zilustrował scenę topienia niewiernej małżonki sułtana Hassana. Okrutnego aktu dokonuje sługa, a sam władca patrzy na wszystko z boku. W drugiej wersji malarz nadał historii rys autobiograficzny. W rolę sułtana wcielił się sam, żona to oczywiście Teodora, a sługą wykonującym wyrok jest – wspomniany już wcześniej – Marian Gorzkowski. Był on od 1876 roku sekretarzem Szkoły Sztuk Pięknych, a także najbliższym współpracownikiem i towarzyszem Matejki.",
  },
  {
    id: 4,
    name: "",
    title: "Rzeczpospolita",
    org:
      "https://www.rp.pl/Rzecz-o-historii/308209979-Jan-Matejko-smutny-wieszcz-z-Krakowa.html",
    desc:
      "Problemy osobiste źle wpływały także na zdrowie Matejki. Artysta cierpiał na wrzody żołądka, a 'leczył się' fatalnie: głodówką i wielkimi ilościami mocnej kawy, dużo przy tym palił. Pracował ponad siły, nawet po 12 godzin dziennie. 30 aździernika 1893 r., pracując nad 'Ślubami Jana Kazimierza', dźwignął jakiś ciężki przedmiot, co spowodowało nagły krwotok wewnętrzny. Zmarł dwa dni później.",
  },
  {
    id: 5,
    name: "",
    title: "mk",
    org:
      "https://www.polskieradio.pl/39/156/Artykul/871226,Jan-Matejko-malarz-dziejow-narodu-polskiego",
    desc:
      "Miał 13 lat, gdy w 1851 roku znalazł się w krakowskiej Szkole Sztuk Pięknych. Jan Matejko był niskiego wzrostu, wręcz karłowaty. W czasie malowania z powodu krótkiego wzroku przykładał do lewego oka specjalne szkiełko. W szkole koledzy nadali mu ośmieszające przydomki – 'ślepowron' i 'męczybuła'.",
  },
];
export default testimonials;
